var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 138,
    viewBox: "0 0 115 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98 54C98 41.0044 93.7857 28.5411 86.2843 19.3518C78.7828 10.1625 68.6087 5 58 5C47.3913 5 37.2172 10.1625 29.7157 19.3518C22.2143 28.541 18 41.0044 18 54L58 54H98Z",
    stroke: "white",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 61C0 55.4772 4.47715 51 10 51H105C110.523 51 115 55.4772 115 61V128C115 133.523 110.523 138 105 138H10C4.47715 138 0 133.523 0 128V61ZM63 110.538C63 106.879 65.334 103.677 67.2685 100.571C68.366 98.8094 69 96.7287 69 94.5C69 88.1487 63.8513 83 57.5 83C51.1487 83 46 88.1487 46 94.5C46 96.7287 46.634 98.8094 47.7315 100.571C49.666 103.677 52 106.879 52 110.538V119.5C52 122.538 54.4624 125 57.5 125V125C60.5376 125 63 122.538 63 119.5V110.538Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.df1fcae56fcf92fcf7fdd6903d65d715.svg";
export { ForwardRef as ReactComponent };